


import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Card from '../Card'
import LineTitle from '@/components/LineTitle';
import { getAllAddress, deleteUserAddress,  AddressInfo } from '@/service/address'
import useSubmitCourse from '@/hooks/submitCourse';
import { isIOS } from '@/utils'
import s from './index.module.css'

const Address: React.FC = () => {

  const [state, setState] = useState<AddressInfo[]>([]);
  const  { submitCourse } = useSubmitCourse();

  const fetchData = () => {
    getAllAddress().then((res) => {
      console.log(res);
      setState(res?.result || []);
    }).catch(err => {
      console.log('lly-log -- err --->', err);
    })
  }

  useEffect(() => {
    fetchData()
  }, []);

  const handleDelete = (id: number) => {
    deleteUserAddress(id).then((res) => {
      console.log(res);
      if(res.success) {
        fetchData()
      }
    }).catch(err => {
      console.log('lly-log -- err --->', err);
    })
  }

  const handleOk = (data: AddressInfo) => {
    submitCourse({
      address: data
    })
  }

  return <div className={`${s.wrap} ${isIOS && s.isIos}`}>
    <LineTitle title={'收货地址'} />
    <div className={s.listBox}>
      {
        state.map((item) => {
          return <Card
            key={item.id}
            address={item}
            onDelete={handleDelete}
            onOK={handleOk}
            id={item.id as number}
          />
        })
      }
    </div>
    <Link
      to={`/address/add${location.search}`}
      className={s.addAddress}
    >
        添加新的收货地址
    </Link>
  </div>;
};
export default Address;
